import { render, staticRenderFns } from "./practicalWantingListByCenter.vue?vue&type=template&id=144159ca&scoped=true&"
import script from "./practicalWantingListByCenter.vue?vue&type=script&lang=js&"
export * from "./practicalWantingListByCenter.vue?vue&type=script&lang=js&"
import style0 from "./practicalWantingListByCenter.vue?vue&type=style&index=0&id=144159ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144159ca",
  null
  
)

export default component.exports